


import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import Messages from '../../../shared/UI/Messages/Messages';
import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddMenuitemcat extends Component {
    state = {
        type: 'add',
        menuCategoryId: null,
        isActive: false,
        categorycode: '',
        categoryName: '',
        CompanyId: this.props.loggedUserDetail.CompanyId,
        createdBy: this.props.loggedUserDetail.userName ?? 'Admin',
        createdDate: new Date(),
        touch: false,
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('res/GetinvMenuCategorybyid?menucategoryid=' + id, this.props.loggedUserDetail.CompanyId);
        this.props.getMasterKeywordList('unit');
        let type = this.props.match.params.type;

        // if (type !== 'add') {
        //     this.timer();
        // }
    }
    componentDidUpdate(prevProps) {
    if (prevProps.tableLists !== this.props.tableLists && this.props.tableLists) {
        let type = this.props.match.params.type;
        let filterData = this.props.tableLists;
        this.setState({
            type: type,
            menuCategoryId: filterData.menuCategoryId,
            isActive: filterData.isActive,
            categorycode: filterData.categorycode,
            categoryName: filterData.categoryName,
        });
    }
}

    // timer = () => {
        
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //         this.setState({ loading: false });
    //     },1000);
    // }

    componentWillUnmount() {
        if (this.props.tableLists !== undefined) {
            clearInterval(this.intervalID);
        }
    }

    // fetchSingleProcess = () => {
    //     this.setState({ loading: true});
    //         console.log('tableLists:', this.props.tableLists);

    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists !== undefined) {
    //         storageItems = this.props.tableLists;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             this.setState({
    //                 type: type,
    //                 menuCategoryId: filterData.menuCategoryId,
    //                 isActive: filterData.isActive,
    //                 categorycode: filterData.categorycode,
    //                 categoryName: filterData.categoryName,
    //             });
    //         }
    //     }
    // }

    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    add = () => {
        var data = {
            companyid: this.state.CompanyId,
            isActive: this.state.isActive,
            categorycode: this.state.categorycode,
            categoryName: this.state.categoryName,
            createdBy: this.state.createdBy,
            createdDate: this.state.createdDate,
        };

        if (this.state.type === 'edit') {
            data.menuCategoryId = this.state.menuCategoryId;
        }

        this.props.processDynamicData('invMenuCategory', this.state.type, data, 'res/GetInvMenuCategorybyid');
    }

    resetData = () => {
        this.setState({
            menuCategoryId: null,
            isActive: false,
            categorycode: '',
            categoryName: '',
            type: 'add',
            touch: false,
        });
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/menuitemcategory/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) {
                this.props.history.push('/dashboard');
            }
            addAccess = this.getAccess.addAccess === true;
            editAccess = this.getAccess.editAccess === true;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess };

        let isEnabled = this.state.touch === true;
        let isViewMode = this.state.type === 'view';

        let redirectURL = '/menuitemcategory/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = '/dashboard';
            }
        }

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type} Item</h1>

                        <div className="p-grid mt1">
                            <div className="p-col-12">
                                <div className="card card-w-title">
                                    <div className="p-grid">

                                        {/* isActive - Switch */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="isActive">Is Active</label>
                                            <div className="mt1">
                                                <InputSwitch
                                                    id="isActive"
                                                    name="isActive"
                                                    checked={this.state.isActive}
                                                    disabled={isViewMode}
                                                    onChange={(e) => this.setState({ isActive: e.value, touch: true })}
                                                />
                                            </div>
                                        </div>

                                        {/* categorycode - InputText */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="categorycode">Category Code <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="categorycode"
                                                    name="categorycode"
                                                    value={this.state.categorycode}
                                                    onChange={this.change}
                                                    placeholder="Category Code"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                        </div>

                                        {/* categoryName - InputText */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="categoryName">Category Name <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="categoryName"
                                                    name="categoryName"
                                                    value={this.state.categoryName}
                                                    onChange={this.change}
                                                    placeholder="Category Name"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                        </div>
                                                                    
                                    </div>
                                </div>
                                        <div className="p-col-12 p-lg-12">
                                          <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />
                                        </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        unitList: state.keyword.unit,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMenuitemcat);